<template>
    <el-form-item
        :rules="{ required: isFieldRequired, validator: validateField, trigger: 'change' }"
        :label="field.label"
        prop="value"
        class="fin-w-full"
        slot="reference">

        <span slot="label">
            {{ field.label }}
            <span v-if="!_.isEmpty(field.content)" class="fin-relative fin-z-50 fin-ml-1"
                :class="isFrontend ? 'fin-hidden' : 'fin-hidden 2xl:fin-inline-flex'">
                <el-popover
                    placement="top-start"
                    :title="field.label"
                    width="200"
                    trigger="hover"
                    :content="field.content"
                    :disabled="_.isEmpty(field.content)"
                    popper-class="app-form-field-popover"
                    >
                    <i slot="reference" class="fas fa-circle-info fin-ml-2 fin-text-warning"></i>
                </el-popover>
            </span>
        </span>

        <div v-if="!_.isEmpty(field.content)" class="content fin-flex fin-w-full"
            :class="isFrontend ? '' : '2xl:fin-hidden'">
            {{ field.content }}
        </div>

        <div class="md:fin-flex md:fin-items-center md:fin-justify-items-center fin-w-full md:fin-space-x-5">
            <el-input
                type="number"
                inputmode="numeric"
                required
                class="md:fin-w-1/2 fin-mb-2 md:fin-mb-0 "
                @focus="setCurrentField(field)"
                v-model="inputValue.years"
                clearable
            >
                <template slot="append">Years</template>
            </el-input>
            <el-input
                type="number"
                inputmode="numeric"
                required
                class="md:fin-w-1/2"
                @focus="setCurrentField(field)"
                v-model="inputValue.months"
                clearable
                @blur="calculateYears"
            >
                <template slot="append">Months</template>
            </el-input>
        </div>
    </el-form-item>
</template>

<script>
import formMixin from "@tenant/app-form/mixins/formMixin"

export default {
    name: "YearsMonths",

    mixins: [formMixin],

    props: {
        field: {
            required: true,
            type: [Object, Array],
        },
        fieldKey: {
            required: true,
            type: Number,
        },
        path: {
            required: true,
            type: [String, Number],
        },
        value: {
            required: false,
        },
        formStore: {
            required: false,
            type: String,
            default: "formStore"
        },
    },

    data() {
        return {
            inputValue: null,
        }
    },

    mounted() {
        let path = this.path.replace('.years,months', '')
        this.$store.dispatch(`${this.formStore}/form/setPagePaths`, `${path}.years`)
        this.$store.dispatch(`${this.formStore}/form/setPagePaths`, `${path}.months`)
    },

    computed: {
        isFieldRequired() {
            return this.field.isRequired
        },
    },

    methods: {
        validateField(rule, value, callback) {
            let years = _.get(this.inputValue, "years", 0)
            let months = _.get(this.inputValue, "months", 0)
            let totalMonths = years * 12 + months

            if (totalMonths <= 0 && this.isFieldRequired) {
                callback(new Error(`Min 1 Month is Required`))
            } else {
                callback()
            }
        },

        calculateYears() {
            let inputMonthsInYears

            let years = _.get(this.inputValue, "years", 0)
            let months = _.get(this.inputValue, "months", 0)

            if (months >= 12) {
                inputMonthsInYears = Math.floor(parseFloat(months / 12))
                years = years ? Number(years) + Number(inputMonthsInYears) : inputMonthsInYears
                let totalMonthsInYears = inputMonthsInYears * 12
                months = Number(this.inputValue.months) - Number(totalMonthsInYears)
            }

            this.inputValue.years = years
            this.inputValue.months = months
        },
    },

    watch: {
        inputValue: {
            handler(inputValue) {
                let path = String(this.path).split(".")
                this.setPathData(path, inputValue)
                this.checkRules(this.field, this.path)
            },
            deep: true,
        },
        value: {
            handler(value) {
                this.inputValue = !_.isNull(value) && typeof value !== "undefined" && !_.isEmpty(value) ? value : {}
            },
            immediate: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.el-input :deep {
    .el-input-group__append {
        @apply fin-bg-white fin-border-2 fin-border-stroke-light fin-rounded-tr-lg fin-rounded-br-lg fin-font-normal fin-text-body fin-pl-0 #{!important};
    }

    input {
        @apply fin-rounded-tr-none fin-rounded-br-none fin-border-r-0 fin-p-0 fin-pl-4 #{!important};
    }
}
</style>
